import moment from "moment";
import { useState, useEffect, useCallback } from "react";
import useCallbackRef from "./useCallbackRef.js";
const buildPersistedKey = (key) => {
  return `pk-${key}`;
};
const persistDueAt = (key, dueAt) => {
  localStorage.setItem(buildPersistedKey(key), dueAt.toISOString());
};
const getPersistedDueAt = (key) => {
  const storedAvailableAt = localStorage.getItem(buildPersistedKey(key));
  return storedAvailableAt ? moment(storedAvailableAt) : null;
};
const useDateAvailCheck = (key) => {
  const [dueAt, setDueAt] = useState(() => getPersistedDueAt(key));
  useEffect(() => {
    const storedAvailableAt = getPersistedDueAt(key);
    if (storedAvailableAt) {
      setDueAt(storedAvailableAt);
    }
  }, [key]);
  const check = useCallbackRef(() => {
    const isExpired = dueAt ? moment().isAfter(dueAt) : true;
    if (isExpired) {
      localStorage.removeItem(buildPersistedKey(key));
    }
    return isExpired;
  });
  const updateDueAt = useCallback(
    (dueAt2) => {
      persistDueAt(key, dueAt2);
      setDueAt(dueAt2);
    },
    [key]
  );
  return { check, updateDueAt, dueAt, key: buildPersistedKey(key) };
};
const useDateAvailCheck$1 = useDateAvailCheck;
export {
  useDateAvailCheck$1 as default,
  getPersistedDueAt,
  persistDueAt
};
